// @ts-nocheck
import { useEffect } from 'react'
import { Landing } from '../components/public/Landing'
import { ContactModal, HelpCenterModal, LanguageModal } from '../components/public/PublicModals'
import { PublicFooter } from '../components/public/PublicFooter'
import { PublicTopbar } from '../components/public/PublicTopbar'
import { usePublicApp } from '../components/public/PublicProvider'
import { applyPublicSeoMetadata } from '../lib/public-seo'

export default function PublicLandingRoute() {
  const app = usePublicApp()

  useEffect(() => {
    applyPublicSeoMetadata(app.locale || 'en')
  }, [app.locale])

  return (
    <>
      <Landing
        onStart={() => app.navigate('/login')}
        onLogin={() => app.navigate('/login')}
        onSignup={() => app.navigate('/signup')}
        Topbar={PublicTopbar}
        Footer={PublicFooter}
        lang={app.lang}
        setLang={app.setLang}
        navigate={app.navigate}
        onContact={() => app.setContactOpen(true)}
        onHelpCenter={() => app.setHelpCenterOpen(true)}
        onLanguages={() => app.setLanguageOpen(true)}
      />
      <ContactModal open={app.contactOpen} onClose={() => app.setContactOpen(false)} lang={app.lang} />
      <LanguageModal
        open={app.languageOpen}
        onClose={() => app.setLanguageOpen(false)}
        lang={app.lang}
        setLang={app.setLang}
      />
      <HelpCenterModal
        open={app.helpCenterOpen}
        onClose={() => app.setHelpCenterOpen(false)}
        lang={app.lang}
      />
    </>
  )
}
